import * as React from "react";
const SvgSubdirectory = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="inherit" viewBox="0 0 24 24" {...props}><path d="m19 15-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9z" /></svg>;
export default SvgSubdirectory;